import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
var ConstructoresComponent = /** @class */ (function () {
    function ConstructoresComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.selectedCon = null;
        this.rut_const = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("constructores"))) {
            localStorage.setItem("constructores", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("constructores"));
        }
        this.invalidRut = true;
        this.constructores = {
            rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: ''
        };
    }
    ConstructoresComponent.prototype.get_Constructores = function (rut) {
        var _this = this;
        window.scroll(0, 0);
        this.spinner.show();
        this._userService.getConstructores(rut).subscribe(function (response) {
            if (response.message) {
                _this.constructores.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.constructores.rut = response.rut ? response.rut : '';
                _this.constructores.nombre = response.nombre ? response.nombre : '';
                _this.constructores.mail = response.mail ? response.mail : '';
                _this.constructores.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.constructores.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.constructores.direccion = response.direccion ? response.direccion : '';
                _this.constructores.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.constructores.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.constructores.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.constructores.comuna = response.comuna ? response.comuna : '';
                _this.constructores.fono = response.fono ? response.fono : '';
                _this.constructores.fax = response.fax ? response.fax : '';
                _this.constructores.patente = response.patente ? response.patente : '';
                _this.constructores.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    ConstructoresComponent.prototype.cleanData = function () {
        this.constructores = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_completa: '', direccion_num: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
        this.rut_const.reset();
    };
    ConstructoresComponent.prototype.update_Constructores = function (rut, id) {
        this.get_Constructores(rut);
        this.selectedCon = id;
    };
    ConstructoresComponent.prototype.saveConstructores = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado        
        for (var x = 0; x < this.rows.length; x++) {
            if (this.constructores.rut == this.rows[x].rut) {
                this.delete_Constructores(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedCon != null) {
            this.delete_Constructores(this.selectedCon);
            this.selectedCon = null;
        }*/
        this.spinner.show();
        this._userService.saveConstructores(this.constructores).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#const_modal").modal("hide");
                _this.actualRow = localStorage.getItem("constructores");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.constructores.rut,
                    nombre: _this.constructores.nombre,
                    apellido_mat: _this.constructores.apellido_mat,
                    apellido_pat: _this.constructores.apellido_pat,
                    direccion: _this.constructores.direccion,
                    direccion_num: _this.constructores.direccion_num,
                    direccion_complemento: _this.constructores.direccion_complemento,
                    direccion_completa: _this.constructores.direccion_completa,
                    comuna: _this.constructores.comuna,
                    fono: _this.constructores.fono,
                    fax: _this.constructores.fax,
                    mail: _this.constructores.mail,
                    patente: _this.constructores.patente
                });
                localStorage.setItem("constructores", JSON.stringify(_this.rows));
                _this.constructores = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_completa: '', direccion_num: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
                _this.rut_const.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    ConstructoresComponent.prototype.delete_Constructores = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("constructores", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('constructores'));
            }
        }
    };
    return ConstructoresComponent;
}());
export { ConstructoresComponent };
